import { Stack } from "expo-router";
import { useUnistyles } from "react-native-unistyles";

export default function AlarmRoutesNativeLayout() {
  const { theme } = useUnistyles();

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: theme.colors.background as string },
        headerTintColor: theme.colors.text as string,
        headerBackButtonDisplayMode: "minimal",
        contentStyle: { backgroundColor: theme.colors.background as string },
      }}
    />
  );
}
